import { useContext } from 'react';
import GlobalComponentsContext from 'src/contexts/GlobalComponentsContext';

const useComponents = () => useContext(GlobalComponentsContext);

export default useComponents;
